// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
import { defer } from 'rxjs';
import { map } from 'rxjs/operators';
import { getOwnerEmailRequestToJson, getOwnerEmailResponseFromJson } from './codec';
import { fetchRpc } from '@vendasta/protos/fetch-transport';
import { getGlobalTransport } from '@vendasta/protos/transport';
export async function getOwnerEmail(request) {
    const raw = await fetchRpc('conversation.v1.EmailService/GetOwnerEmail', getOwnerEmailRequestToJson(request));
    return getOwnerEmailResponseFromJson(raw);
}
export function getOwnerEmail$(request, options) {
    return defer(() => getOwnerEmailWithTransport$(getGlobalTransport(), request, options));
}
export function getOwnerEmailWithTransport$(transport, request, options) {
    return transport
        .post('conversation.v1.EmailService/GetOwnerEmail', getOwnerEmailRequestToJson(request), options)
        .pipe(map(resp => getOwnerEmailResponseFromJson(resp)));
}
